<template>
    <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.42857 1C7.42857 0.447715 7.87629 0 8.42857 0H22C22.5523 0 23 0.447715 23 1V20.25C23 21.2404 22.6118 22.1928 21.9167 22.897C21.2212 23.6017 20.2751 24 19.2857 24H8.42857C7.87629 24 7.42857 23.5523 7.42857 23C7.42857 22.4477 7.87629 22 8.42857 22H19.2857C19.7361 22 20.1708 21.8188 20.4933 21.4921C20.8163 21.1649 21 20.7183 21 20.25V2H8.42857C7.87629 2 7.42857 1.55228 7.42857 1ZM11.7975 7.16329C12.1906 6.77532 12.8237 6.77946 13.2117 7.17253L17.2831 11.2975C17.6675 11.687 17.6675 12.313 17.2831 12.7025L13.2117 16.8275C12.8237 17.2205 12.1906 17.2247 11.7975 16.8367C11.4045 16.4487 11.4003 15.8156 11.7883 15.4225L14.1794 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H14.1794L11.7883 8.57747C11.4003 8.1844 11.4045 7.55125 11.7975 7.16329Z"
            fill="currentColor"
        />
    </svg>
</template>
